import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface SimpleWaringIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function SimpleWarningIcon({ color = RoutalPalette.neutral00, style = {} }: SimpleWaringIconProps) {
  return (
    <SvgIcon viewBox="0 0 2 14" style={{ width: `2px`, height: `14px`, fill: `none`, ...style }}>
      <path
        d="M1.20349 0.777832V9.00195"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.20349 12.8306H1.21981"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
